export default __webpack_public_path__ + "static/media/comboio.fbc88649.svg";